import AnswerResponse from '@/domain/survey/entity/answer-response.entity';

export default class CandidateReasoningResult {
  surveyAnswerId: string;

  name: string;

  resultTotal: number;

  percent: number;

  answers: AnswerResponse[];

  startedDate: string;

  concludedDate: string;

  constructor(obj: any = {}) {
    this.surveyAnswerId = obj.surveyAnswerId || '';
    this.name = obj.name || '';
    this.resultTotal = obj.resultTotal;
    this.percent = obj.percent;
    this.answers = obj.answers
      ? obj.answers.map((answer: any) => new AnswerResponse(answer)) : [];
    this.startedDate = obj.startedDate
    this.concludedDate = obj.concludedDate;
  }
}
